import { render } from "./yong-feedback.vue?vue&type=template&id=41d5917c&scoped=true"
import script from "./yong-feedback.vue?vue&type=script&lang=js"
export * from "./yong-feedback.vue?vue&type=script&lang=js"

import "./yong-feedback.vue?vue&type=style&index=0&id=41d5917c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d5917c"]])

export default __exports__